import React, { useEffect, memo, useCallback } from "react";
import cls from "classnames";
import { Mask } from "@al/akui-mobile";
import { withRedux, WithReduxHocPropsType, useT } from "@al/next/al-ex";
import { EventType } from "@al/event-tracking-sensor-analytics";

import linkTo from "~/common/utils/linkTo";
import { tracker } from "~/common/tracker";

import { getTrackerSaReportInfo } from "../../../sensor-config";

import styles from "./index.scss";

interface Props extends WithReduxHocPropsType {
  visible: boolean;
  openAppLink: string;
  onCancel: () => void;
  onDownLoadApp: () => void;
}

const RedeemModal = (props: Props): JSX.Element => {
  const t = useT();
  useEffect(() => {
    if (props.visible) {
      tracker.expose({
        sa: {
          event: EventType.PopView,
          ...getTrackerSaReportInfo({ page: "homePage", popName: "redeemPop" }),
        },
      });
    }
  }, [props.visible]);

  const handleDownLoadApp = useCallback((): void => {
    tracker.popClick({
      sa: getTrackerSaReportInfo({ page: "homePage", popName: "redeemPop", eventName: "clickDownApp" }),
    });
    props?.onDownLoadApp();
    props?.openAppLink && linkTo(props.openAppLink);
  }, [props.openAppLink]);

  const handleCancel = useCallback((): void => {
    tracker.popClick({
      sa: getTrackerSaReportInfo({ page: "homePage", popName: "redeemPop", eventName: "clickCancel" }),
    });
    props.onCancel?.();
  }, []);

  return (
    <Mask className={styles.download_modal} visible={props.visible} disableBodyScroll opacity={0.75} destroyOnClose>
      <div className={styles.title}>{t("全网最低价,0首付")}</div>
      <div className={styles.content}>
        <div>
          <div className={styles.tip}>{t("下载akulaku")}</div>
          <div className={styles.sub_tip}>{t("新用户可领优惠券新用户可领优惠券")}</div>
        </div>
        <div className={styles.price}>
          165
          <span className={styles.unit}>RB</span>
        </div>
      </div>
      <div className={styles.btn} onClick={handleDownLoadApp}>
        {t("去领取")}
      </div>
      <div className={cls(styles.btn_cancel, styles.btn)} onClick={handleCancel}>
        {t("下次再说")}
      </div>
    </Mask>
  );
};

export default withRedux((state) => ({
  openAppLink: state.static.openAppLink,
}))(memo(RedeemModal));
